(function () {
  function normalize(value) {
    return String(value || '').trim();
  }

  function sortNatural(items) {
    return Array.from(items).filter(Boolean).sort(function (a, b) {
      return String(a).localeCompare(String(b), undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
  }

  function getOptionIndexes(product) {
    var indexes = {
      size: -1,
      width: -1,
      color: -1
    };

    (product.options || []).forEach(function (optionName, index) {
      var name = String(optionName || '').toLowerCase().trim();

      if (indexes.size === -1 && name.indexOf('size') !== -1) {
        indexes.size = index;
      }

      if (indexes.width === -1 && name.indexOf('width') !== -1) {
        indexes.width = index;
      }

      if (indexes.color === -1 && name.indexOf('color') !== -1) {
        indexes.color = index;
      }
    });

    return indexes;
  }

  function getVariantOption(variant, index) {
    if (index === 0) return normalize(variant.option1);
    if (index === 1) return normalize(variant.option2);
    if (index === 2) return normalize(variant.option3);
    return '';
  }

  function buildAvailabilityTable(container, product) {
    var indexes = getOptionIndexes(product);

    if (indexes.size === -1 || indexes.color === -1) {
      return;
    }

    var variants = product.variants || [];
    var sizes = new Set();
    var widths = new Set();

    variants.forEach(function (variant) {
      var size = getVariantOption(variant, indexes.size);
      var width = indexes.width === -1 ? 'Standard' : getVariantOption(variant, indexes.width);

      if (size) sizes.add(size);
      if (width) widths.add(width);
    });

    sizes = sortNatural(sizes);
    widths = sortNatural(widths);

    if (!sizes.length || !widths.length) {
      return;
    }

    var html = '';

    html += '<div class="product-availability-block">';
    html += '<div class="product-availability-header"><h3>Availability Table</h3></div>';

    html += '<p class="product-availability-intro">';
    html += 'Check live size and width availability at a glance. Green means in stock, red means out of stock, and black means unavailable.';
    html += '</p>';

    html += '<div class="availability-legend">';
    html += '<span class="availability-legend__item"><span class="availability-legend__swatch availability-legend__swatch--green"></span> In stock</span>';
    html += '<span class="availability-legend__item"><span class="availability-legend__swatch availability-legend__swatch--red"></span> Out of stock</span>';
    html += '<span class="availability-legend__item"><span class="availability-legend__swatch availability-legend__swatch--black"></span> Unavailable</span>';
    html += '</div>';

    widths.forEach(function (width) {
      var colors = new Set();

      variants.forEach(function (variant) {
        var variantWidth = indexes.width === -1 ? 'Standard' : getVariantOption(variant, indexes.width);
        var variantColor = getVariantOption(variant, indexes.color);

        if (variantWidth === width && variantColor) {
          colors.add(variantColor);
        }
      });

      colors = sortNatural(colors);

      if (!colors.length) {
        return;
      }

      html += '<div class="availability-width-block">';
      html += '<div class="availability-width-title">' + escapeHtml(width) + ' Width</div>';

      html += '<div class="availability-table-wrap">';
      html += '<table class="availability-table">';
      html += '<thead><tr><th>Color</th>';

      sizes.forEach(function (size) {
        html += '<th>' + escapeHtml(size) + '</th>';
      });

      html += '</tr></thead><tbody>';

      colors.forEach(function (color) {
        html += '<tr>';
        html += '<td class="availability-color-name">' + escapeHtml(color) + '</td>';

        sizes.forEach(function (size) {
          var status = 'black';

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];

            var variantSize = getVariantOption(variant, indexes.size);
            var variantWidth = indexes.width === -1 ? 'Standard' : getVariantOption(variant, indexes.width);
            var variantColor = getVariantOption(variant, indexes.color);

            if (
              variantSize === size &&
              variantWidth === width &&
              variantColor === color
            ) {
              status = variant.available ? 'green' : 'red';
              break;
            }
          }

          html += '<td class="availability-cell">';
          html += '<span class="availability-status availability-status--' + status + '"></span>';
          html += '</td>';
        });

        html += '</tr>';
      });

      html += '</tbody></table></div></div>';
    });

    html += '<p class="availability-note">';
    html += 'Inventory changes throughout the day. If a size shows limited stock, it may sell out quickly.';
    html += '</p>';

    html += '</div>';

    container.innerHTML = html;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initAvailabilityTables() {
    document.querySelectorAll('.product-availability-js[data-product]').forEach(function (container) {
      try {
        var product = JSON.parse(container.getAttribute('data-product'));
        buildAvailabilityTable(container, product);
      } catch (error) {
        console.warn('Availability table failed to load:', error);
      }
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initAvailabilityTables);
  } else {
    window.addEventListener('load', initAvailabilityTables);
  }
})();